<template>
  <div id="app" class="min-h-screen bg-gray-50">
    <!-- Header (hide on auth pages) -->
    <AppHeader v-if="!isAuthPage" />

    <!-- Main Content -->
    <main :class="isAuthPage ? '' : 'container mx-auto px-4 py-8'">
      <router-view />
    </main>

    <!-- Footer (hide on auth pages) -->
    <Footer v-if="!isAuthPage" />

    <!-- Onboarding Tutorial -->
    <OnboardingTutorial />
  </div>
</template>

<script>
import { computed } from "vue";
import { useRoute } from "vue-router";
import AppHeader from "@/components/Layout/Header.vue";
import Footer from "@/components/Layout/Footer.vue";
import OnboardingTutorial from "@/components/OnboardingTutorial.vue";

export default {
  name: "App",
  components: {
    AppHeader,
    Footer,
    OnboardingTutorial,
  },
  setup() {
    const route = useRoute();

    const isAuthPage = computed(() => {
      return route.path === "/login" || route.path === "/register";
    });

    return {
      isAuthPage,
    };
  },
};
</script>

<style scoped>
.container {
  max-width: 1200px;
}
</style>
